import { View } from "@/components/ui/view";
import { CreditTransactionListCard } from "./CreditTransactionListCard";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button";
import type { ClientCreditAccountTransactions } from "@/types/profile";

export const CreditAccountTransactionScreen = ({
  transactions,
  onBack,
}: {
  transactions: ClientCreditAccountTransactions;
  onBack(): void;
}) => {
  return (
    <View className="flex flex-col gap-4">
      <View className="static flex flex-1 flex-row items-center justify-between border-b">
        <View className="flex flex-row items-center gap-2 p-4 md:pl-0 md:pt-0">
          <IconButton
            iconName="arrowLeft"
            variant="secondary"
            rounded="full"
            color="foreground"
            className="w-[48px]"
            onClick={onBack}
          />
          <Typography variant="label-md">Transaction History</Typography>
        </View>
      </View>
      <CreditTransactionListCard transactions={transactions} />
    </View>
  );
};
